import React, { useState } from 'react';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { setSearchTerm } from '../redux/slices/searchSlice';
import { FaSearch } from "react-icons/fa";

interface SearchBarProps {
    id: string;
    label?: string;
    className?: string;
    iconColor?: string;
}

const SearchBar: React.FC<SearchBarProps> = ({ id, className = "", label = "Search...", iconColor = "white" }) => {
    const [isFocused, setIsFocused] = useState(false);
    const dispatch = useAppDispatch();
    const searchTerm = useAppSelector((state) => state.search.terms["resourcesSearch"]) || "";

    const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        dispatch(setSearchTerm({ id: id, term: event.target.value }));
    };

    return (
        <div className={`flex items-center mb-4 rounded-sm`}>
            <input
                type="search"
                name="search"
                placeholder={label}
                className={`${className} outline-none focus:ring-custom-blue ${isFocused ? 'ring-2 ring-ekc-blue' : ''}`}
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
                onChange={handleSearchChange}
                autoComplete='off'
                value={searchTerm}
            />
            <FaSearch className="w-5 h-5 text-white ml-[-40px] z-10" color={iconColor} />
        </div>
    );
};

export default SearchBar;
